export class ProviderContact {
    providerName: string | undefined;
    address: string | undefined;
    contactName: string | undefined;
    contactPhoneNumber: string | undefined;
    contactEmail: string | undefined;
    webSite: string | undefined;
    constructor(options?: Partial<ProviderContact>) {
        Object.assign(this, options);
    }
}
